<ng-container *ngFor="let childItem of menuItem.children">

  <!-- Level-2: expandable sub-section (e.g. Career Site Experience inside Views) -->
  <mat-expansion-panel
    *ngIf="childItem.type === 'sub'
      && menuItem.state !== 'cande-fake-menu-1'
      && menuItem.state !== 'cande-fake-menu-2'"
    [class.hidden]="!childItem.visible"
    [class]="childItem.customCssClass"
    [expanded]="isExpanded(childItem.state)"
    (opened)="onPanelOpened(childItem.state)"
    (closed)="onPanelClosed(childItem.state)"
    class="sidebar-exp-panel sidebar-exp-panel--l2">
    <mat-expansion-panel-header class="sidebar-exp-header sidebar-exp-header--l2">
      <mat-panel-title class="sidebar-exp-title">
        {{ childItem.name | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <!-- Level-3 leaf links -->
    <ng-container *ngFor="let subChildItem of childItem.children">
      <a *ngIf="!subChildItem.hidden && subChildItem.visible !== false"
        class="sidebar-leaf-link sidebar-leaf-link--l3"
        [class.hidden]="subChildItem.visible === false"
        [class]="subChildItem.customCssClass"
        [routerLink]="getSubChildRoute(childItem, subChildItem)"
        routerLinkActive="active"
        mat-ripple>
        {{ subChildItem.name | translate }}
      </a>
    </ng-container>
  </mat-expansion-panel>

  <!-- Level-2: direct link (e.g. Surveys inside Toolkit) -->
  <app-sub-menu-item
    *ngIf="childItem.type !== 'sub' && childItem.visible !== false"
    [childItem]="childItem"
    [menuItem]="menuItem">
  </app-sub-menu-item>

</ng-container>
